import type { State } from '../../types';
import type { ContractViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function getContracts(state: State): ContractViewModel[] {
  return state.organization !== undefined ? toList(state.organization.contractsById) : [];
}
